import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MomSysWageRate ( props ) {

    return <BasicCrudScreenType id="MomSysWageRate" table="MomSysWageRate" view="MomSysVwWageRate" />;

}

export default MomSysWageRate;
